import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'custom-rostering',
    components: {},
})

export default class CustomRostering extends Vue {

    @Prop()
    private ssoDetails: any;

}
